/**
 * Expands filter sessions for Firebase `variableDiscountAvailability` paths.
 * Dinner includes Dinner2 unless Last Table narrows to Dinner2 only.
 *
 * Per-restaurant support is applied later when building sessions-by-id
 * (`firstTableSessionTypes` or `walkInSessionTypes`).
 */
export default function expandSessionsForFirebase(
  sessions: SessionType[],
  hasLastTable: boolean,
): SessionType[] {
  const filterSessions = new Set<SessionType>();

  for (const session of sessions) {
    if (session === "Dinner" || session === "Dinner2") {
      if (hasLastTable) {
        filterSessions.add("Dinner2");
      } else {
        filterSessions.add("Dinner");
        filterSessions.add("Dinner2");
      }
      continue;
    }

    filterSessions.add(session);
  }

  return [...filterSessions];
}
